const AIAvatarIdle = ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        {/* Antenna */}
        <path d="M12 2V5" className="stroke" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="2" r="1.5" className="fill" />

        {/* Robot Head */}
        <rect x="3" y="5" width="18" height="16" rx="5" className="head" strokeWidth="2" />

        {/* Ears */}
        <path d="M1 10H3" className="stroke" strokeWidth="2" strokeLinecap="round" />
        <path d="M21 10H23" className="stroke" strokeWidth="2" strokeLinecap="round" />

        {/* Eyes */}
        <circle cx="9" cy="11" r="1.5" className="fill" />
        <circle cx="15" cy="11" r="1.5" className="fill" />

        {/* Smile */}
        <path
            d="M9 15C9 15 10.5 16.5 12 16.5C13.5 16.5 15 15 15 15"
            className="stroke"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default AIAvatarIdle
